<div class="flex flex-col">
  <div class="flex flex-row items-center justify-between w-full">
    <span class="">
      {{ data.message }}
    </span>
    <span class="text-blue-300 ml-2">
      {{ data.action }}
    </span>
  </div>
</div>
